export const DEFAULT_TAX_RATE = 8.1;

export const MAX_IMAGE_FILE_SIZE = 5 * 1024 * 1024; // 5MB
